<!-- =========================================================================================
    File Name: TodoAddNew.vue
    Description: Add new todo component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="px-6 pb-2 pt-6">
    <vs-button @click="activePrompt = true" class="w-full">Add New</vs-button>
    <vs-prompt
      title="New Health Hacks Post"
      accept-text="Save"
      button-cancel="border"
      @cancel="clearFields"
      @accept="addTodo"
      @close="clearFields"
      :is-valid="validateForm"
      :active.sync="activePrompt"
    >
      <div>
        <form>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Category</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <v-select
                    :options="['Allergy', 'Asthma']"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-validate="'required'"
                    name="category"
                    placeholder="Category"
                    class="w-full"
                    v-model="taskLocal.category"
                    :color="validateForm ? 'success' : 'danger'"
                  />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Video URL</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    v-validate="'required'"
                    name="video URL"
                    placeholder="Video URL"
                    class="w-full"
                    v-model="taskLocal.video_url"
                    :color="validateForm ? 'success' : 'danger'"
                  />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Video title</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input
                    v-validate="'required'"
                    name="video title"
                    placeholder="Video title"
                    class="w-full"
                    v-model="taskLocal.video_title"
                    :color="validateForm ? 'success' : 'danger'"
                  />
                </div>
              </div>
              <div class="vx-row mb-6">
                <div class="vx-col sm:w-1/3 w-full">
                  <span>Thumbnail</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vx-input-group class="mb-base">
                    <vs-input
                      v-validate="'required'"
                      name="thumbnail"
                      placeholder="Thumbnail"
                      class="w-full"
                      v-model="taskLocal.thumbnail"
                      :color="validateForm ? 'success' : 'danger'"
                    />

                    <template slot="append">
                      <div class="append-text bg-primary">
                        <i class="person"></i>
                      </div>
                    </template>
                  </vx-input-group>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import vSelect from "vue-select";
import DataProvider from "../../../services/data-provider";
export default {
  components: {
    "v-select": vSelect,
  },
  created() {
    this.setSidebarWidth();
    bus.$on("edit_item_data", (data) => {
      console.log(data);
      this.editData(data)
    })
  },
  data() {
    return {
      activePrompt: false,

      taskLocal: {
        category: "",
        video_url: "",
        video_title: "",
        thumbnail: "",
        questions: [],
      },
    };
  },
  computed: {
    taskTags() {
      return this.$store.state.todo.taskTags;
    },
    validateForm() {
      return !this.errors.any() && this.taskLocal.category !== "";
    },
  },
  methods: {
    clearFields() {
      Object.assign(this.taskLocal, {
        category: "",
        video_url: "",
        video_title: "",
        thumbnail: "",
      });
    },
    addTodo() {
      console.log(this.taskLocal);
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log(result);
          DataProvider.postDataToCloud("/health_hacks", this.taskLocal).then(
            (data) => {
              console.log("Data:", data);
              this.clearFields();
            }
          );
          // this.$store.dispatch(
          //   "todo/addTask",
          //   Object.assign({}, this.taskLocal)
          // );
        }
      });
    },
  },
};
</script>
<style scoped>
</style>
